import { render, staticRenderFns } from "./Product2.vue?vue&type=template&id=4603c45c&"
import script from "./Product2.vue?vue&type=script&lang=js&"
export * from "./Product2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports